import { LineChartData } from '../../features/chart/chartTypes';
import { angeschlosseneAnlage, anlagentyp, gespeicherteSuche, messgroesse, messstelle, recorder } from '../../utils/apiTypes';
import { LatLngBoundsExpression } from 'leaflet';

export interface netzwirtschaftState {
    selectedTab: number;
    tabs: Array<TabData>;
    uwsList: Array<string>;
    messpunkteSelectList: Array<messstelle>;
    selectAllMessgroesse: boolean;
    multiView: multiViewType;
    multiViewDisabled: boolean;
    anlagentypen: Array<anlagentyp>;
    angeschlosseneAnlagen: Array<angeschlosseneAnlage>;
    gespeicherteSuchen: Array<gespeicherteSuche>;
    sucheLoading: boolean;
    listLoading: boolean;
    umspannwerkLoading: boolean;
    messpunktLoading: boolean;
    rekorderLoading: boolean;
    viewMode: string;
}

export interface TabData {
    name: string;
    index: number;
    fields: netzwirtschaftFieldsData;
    rekorderOptions: Array<recorder>;
    messgroesseOptions: Array<messgroesse>;
    graphLoading: boolean;
    exportLoading: boolean;
    graphData: LineChartData;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    csvData: Array<any>;
    mapBounds: LatLngBoundsExpression;
    showAngeschlosseneAnlagen: boolean;
    resetDatePicker: boolean;
}

export interface netzwirtschaftFieldsData {
    uw: string;
    messpunkt: string;
    rekorder: recorder;
    messgroesse: Array<messgroesse>;
    ersteDaten: Date,
    letzteDaten: Date,
    startDatum: Date;
    endDatum: Date;
}

export interface fieldUpdate {
    field: string,
    value: string | { beschreibung: string, klasse: string, hersteller: string, kategorie: string, messstelle: string } | string[] | Date | messgroesse[]
}

export enum multiViewType {
    single,
    multipleRows,
    twoCols
}

export enum ereignistyp {
    netzereignis,
    pqereignis,
    stoerschrieb
}

export interface ereignis {
    typ: ereignistyp,
    zeit: number,
    ende: number,
    beschreibung: string,
}